import axios from 'axios'

export default {
    download(filter) {
        return axios.download('/api/parts/export',
            {
                no: filter.text,
                productId: filter.productId,
                description: filter.text,
                code: filter.text
            });
    },
    getParts(page, productId, text) {
        return axios.get('/api/parts',
            {
                params: {
                    page: page,
                    no: text,
                    productId: productId,
                    description: text,
                    descriptionFr: text,
                    code: text
                }
            });
    },
    getPart(id) {
        return axios.get(`/api/parts/${id}`);
    },
    savePart(id, part) {
        if (id) {
            return axios.put(`/api/parts/${id}`, part);
        }
        return axios.post('/api/parts', part);
    },
    deletePart(id) {
        return axios.delete(`/api/parts/${id}`);
    },
    upload(file) {
        var formData = new FormData();
        formData.append('file', file);
        return axios.post('/api/parts/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    saveParts(parts) {
        return axios.post('/api/parts/saveparts', parts);
    },
    uploadConfirm(file) {
        var formData = new FormData();
        formData.append('file', file);
        return axios.post('/api/parts/importConfirmation', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    backup() {
        return axios.download('/api/parts/backup');
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/masters/parts/api.js